import React, {useEffect, useState} from 'react';
import '../css/PaginaPontoMototaxi.css';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { FaList, FaUserPlus, FaDollarSign, FaUser, FaWhatsapp, FaLock } from "react-icons/fa";
import Cookies from 'js-cookie';

function PaginaPontoMototaxi() {

  const navigate = useNavigate();
  const [dadosPontoMototaxi, setDadosPontoMototaxi] = useState(null);
  const [dadosUsuario, setDadosUsuario] = useState(null);

  const handleLogout = () => {
    Cookies.remove('dadosCookies');
    navigate('/conta');
  };


  // ✅ Mostra os cookies no console ao carregar o componente
  useEffect(() => {

    console.log('Entrou no useEffect do Cadastrar Piloto Mototaxi.... cookies...');

    const cookies = Cookies.get(); // retorna objeto
    //  com todos os cookies
    const dadosCookiesString = cookies.dadosCookies;

    if (dadosCookiesString) {
        try {
            const dadosCookies = JSON.parse(dadosCookiesString); // transforma string em objeto
            const dadosPontoMototaxi = dadosCookies.dadosPontoMototaxi;
            const dadosUsuario = dadosCookies.dadosUsuario;
            
            console.log('Dados cookies:', dadosCookies);
            console.log('Dados ponto mototaxi:', dadosPontoMototaxi);

            setDadosPontoMototaxi(dadosPontoMototaxi);
            setDadosUsuario(dadosUsuario);

        } catch (e) {
            console.error('Erro ao fazer parse dos dadosCookies:', e);
        }
    } else {
        console.warn('Cookie "dadosCookies" não encontrado');
    }
  }, []);




return (
  <div className="pagina-representante-comercial container py-4">
    <h3 className="mb-4">Painel do Ponto</h3>
    <hr />

    {/* Card com informações do ponto */}
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-body">
        <h4 className="card-title mb-2">
          <strong>{dadosUsuario?.name}</strong>
        </h4>
        <h6 className="text-muted mb-3">Seu Representante:</h6>
        <p className="mb-1">
          <strong>{dadosPontoMototaxi?.objRepresentanteComercial?.nome_representante_comercial}</strong>
        </p>
        <p>
          <a
            href={`https://wa.me/55${dadosPontoMototaxi?.objRepresentanteComercial?.numero_celular_com_ddd.replace(/\D/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success d-inline-flex align-items-center"
          >
            <FaWhatsapp size={20} className="me-2" />
            {dadosPontoMototaxi?.objRepresentanteComercial?.numero_celular_com_ddd}
          </a>
        </p>
      </div>
    </div>

    {/* Opções */}
    <div className="opcoes-container d-flex flex-wrap gap-3">
      <Link to="/listar-piloto-mototaxi" className="opcao-box card p-3 text-center shadow-sm flex-fill">
        <FaList size={40} className="mb-2 text-primary" />
        <span>Listar pilotos cadastrados</span>
      </Link>

      <Link to="/cadastrar-piloto-mototaxi" className="opcao-box card p-3 text-center shadow-sm flex-fill">
        <FaUserPlus size={40} className="mb-2 text-success" />
        <span>Cadastrar novo piloto</span>
      </Link>

      <Link to="/listar-localidades-atendidas" className="opcao-box card p-3 text-center shadow-sm flex-fill">
        <FaList size={40} className="mb-2 text-info" />
        <span>Listar localidades atendidas</span>
      </Link>

      <Link to="/cadastrar-localidades-atendidas" className="opcao-box card p-3 text-center shadow-sm flex-fill">
        <FaDollarSign size={40} className="mb-2 text-warning" />
        <span>Cadastrar localidades</span>
      </Link>

      <Link to="/cadastrar-servicos-atendidos" className="opcao-box card p-3 text-center shadow-sm flex-fill">
        <FaDollarSign size={40} className="mb-2 text-danger" />
        <span>Cadastrar tabela de preços</span>
      </Link>

      <Link to="/alterar-senha-ponto-mototaxi" className="opcao-box card p-3 text-center shadow-sm flex-fill" >
        <FaLock size={40} className="mb-2 text-primary" />
        <span>Alterar Senha</span>
      </Link>

    </div>

    {/* Botão sair */}
    <div className="mt-4 text-center">
      <button onClick={handleLogout} className="btn btn-danger btn-lg shadow">
        Sair
      </button>
    </div>
  </div>
);



}

export default PaginaPontoMototaxi;
